module.exports = __webpack_public_path__ + "assets/img/dfa-di.e876edef.png";